var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#212121"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4195_20097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8982 15.1441L26.8295 23.3895C27.5861 24.7529 28.2455 28.7987 29.9893 28.7987C30.3413 28.7987 30.847 28.6733 31.2799 28.471L31.1464 31.0684C30.491 31.4204 29.5078 32.0354 28.6016 32.0354C25.0858 32.0354 24.8349 27.0307 23.6212 24.9309H21.5983L20.429 31.5337L17.249 31.5782L16.7676 31.0846L19.6765 14.5898H23.4189L22.1566 21.67H24.3575L29.1316 14.5898H32.9994L32.8982 15.1441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0743 32.8935L31.1471 31.0608L30.9367 31.1579C30.3258 31.3966 29.723 31.5139 29.0918 31.5139C28.1492 31.5139 27.3481 31.255 26.6401 31.0244C26.0332 30.8302 25.5153 30.6643 25.0743 30.7169C24.4311 30.7938 24.1074 31.2914 23.9496 31.789C23.7878 31.2873 23.4682 30.7938 22.8249 30.7169C22.3879 30.6643 21.8701 30.8302 21.2591 31.0244C20.5511 31.2509 19.746 31.5139 18.8074 31.5139C18.1803 31.5139 17.5734 31.3966 16.9625 31.1579L16.7642 31.081L16.4123 32.8935H15.6962L15.502 33.6096H32.1666L31.936 32.8935H31.0743Z",
    fill: "#88C425"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4195_20097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4981,
    height: 19.0234,
    fill: "white",
    transform: "translate(15.502 14.5879)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.941cecbd334e23d6aedae033abd92da1.svg";
export { ForwardRef as ReactComponent };